import styled from 'styled-components';

const Card = styled.div`
  display: flex;
  border-radius: 8px;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
  overflow: ${props => (props.showOverflow ? 'visible !important' : 'hidden')};

  ${props => props.selfStart && ' align-self: flex-start;'};

  ${props => props.marginB && ` margin-bottom: ${props.marginB}px;`};

  ${props => props.marginT && `margin-top: ${props.marginT}px; `};

  ${props => props.theme.media.tablet` margin: 20px 0; margin-bottom: 20px;`};
`;

const CardHeaderContainer = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
  padding: 1rem;
  background-color: #fff;
`;

const HeaderTitle = styled.h5`
  font-size: ${props => props.theme.font.md};
  font-size: ${props => props.theme.font.bold};
  color: ${props => props.theme.colors.textPrimary};
  margin: 10px 0;
`;

const HeaderSubtitle = styled.h6`
  font-size: ${props => props.theme.font.xs};
  text-transform: uppercase;
  margin-top: 4px;
  font-size: ${props => props.theme.font.regular};
  color: ${props => props.theme.colors.secondary};
  margin-bottom: 10px;
`;

const CardBody = styled.div`
  padding: 1.25rem;
  ${props => props.scrollX && ' overflow-x: auto; '};

  ${props =>
    props.flexColumn &&
    `
    display: flex;
    flex-direction: column;
  `}
`;

const BodyText = styled.p`
  font-weight: 600;
  color: ${props => props.theme.colors.dusk};
`;

const CardFooter = styled.div`
  padding: 1.25rem 1.5rem;
  border-top: 1px solid rgba(224, 224, 224, 1);
  background-color: #fff;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export { Card, CardHeaderContainer, CardBody, CardFooter, HeaderTitle, HeaderSubtitle, BodyText };
